export class LoginResult {
  public accessToken = '';
}
